exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".watchlist-product{border-radius:10px}.watchlist-product .card-body{padding:12px 16px}.watchlist-product .dropdown-menu{width:100%;max-width:340px;background:var(--background-color)}.watchlist-product .dropdown-menu>div{overflow:auto;max-height:320px}.watchlist-product .dropdown-submenu{-webkit-user-select:none;-ms-user-select:none;-moz-user-select:none;user-select:none}.watchlist-product .discount-badge{padding:3px 6px;border-radius:5px;color:#fff}.watchlist-product .previous-price{color:var(--text-subtle);text-decoration:line-through;opacity:.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-411c370a","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/watchlist/watchlistProduct.vue
// module id = 1Adr
// module chunks = 11 18 32